import React from 'react';

import CountUp from 'react-countup';

import { Percent, Value, Wrapper } from './styles';

interface Props {
    value: number;
    currency?: string;
    percent?: number;
    diffDirection?: 'up' | 'down';
}

export const PriceField = ({ value, currency, percent, diffDirection }: Props) => {
    return (
        <Wrapper>
            <Value>
                <CountUp
                    end={value}
                    decimal="."
                    prefix={currency === 'usd' ? '$' : ''}
                    decimals={currency === 'usd' ? 2 : 4}
                    preserveValue
                />
            </Value>
            {percent && (
                <Percent $diffDirection={diffDirection}>
                    {diffDirection === 'up' ? '+' : '-'}
                    {percent}%
                </Percent>
            )}
        </Wrapper>
    );
};
